export default "__VITE_ASSET__ad6a6aec__"